import { gql } from 'apollo-angular';

const GET_OFFERS = gql`
  query offers($input: OffersByRfpIdInput!) {
    offersByRfpId(input: $input) {
      id
      name
      status
      isValidForSubmission
      unorderedPricing
      unorderedTiers
      productStats {
        isValidForSubmission
        productPricingStatus
      }
      supportedOfferTerm {
        commitmentType
      }
      term {
        isValidForSubmission
      }
      offerTiers {
        isValidForSubmission
      }
    }
  }
`;

export default GET_OFFERS;
